module.exports = __webpack_public_path__ + "assets/99f136374ad8f526035395ced761bccf.mp3";